import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfirmDialog } from './components/ConfirmDialog';
import './styles.css';
import { loadBrandLogos } from './catalog/brandLogos';
import { loadProjectFromUrlIfPresent } from './api/loadProjectFromUrl';

// Kick off the brand-logo manifest fetch as early as possible.
// Fire-and-forget — by the time the user has done anything that
// needs a logo (clicking a model, opening the title block, etc.)
// the manifest will be in cache. If the backend is unreachable we
// fall back to initials badges silently.
void loadBrandLogos();

// SP project handoff — when opened with ?project=<qid> in the URL
// (from SP's publish menu), fetch the matching topology and seed
// the editor with it. No-op for direct/standalone visits.
void loadProjectFromUrlIfPresent();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      {/* Mounted at root so the dialog overlays everything (ReactFlow,
          panels, etc) when triggered via store.askConfirm(). */}
      <ConfirmDialog />
    </ErrorBoundary>
  </React.StrictMode>
);
